import { render } from "./OrderOverview.vue?vue&type=template&id=21b38319"
import script from "./OrderOverview.vue?vue&type=script&lang=ts"
export * from "./OrderOverview.vue?vue&type=script&lang=ts"

import "./OrderOverview.vue?vue&type=style&index=0&id=21b38319&lang=css"
script.render = render

export default script